import React from 'react';
import { ButtonType } from '../../../SharedComponents/Button/ButtonType';
import CustomButton from '../../../SharedComponents/Button/CustomButton';
import AppContainer from '../../../SharedComponents/Container/AppContainer';
import BodyContainer from '../../../SharedComponents/Container/BodyContainer';
import CustomImg from '../../../SharedComponents/CustomImage/CustomImg';
import Header from '../../../SharedComponents/Header/HeaderRefactor';
import BulletList from '../../../SharedComponents/List/BulletList';
import CustomTypography, {
    TypographyType,
} from '../../../SharedComponents/Typography/CustomTypography';
import {
    ButtonResource,
    HeaderResource,
    ImageResource,
    TextResource,
    VoidReturn,
} from '../../../Utils/PageUtils';
import './TroubleShootingStyle.scss';

export type TroubleShootingHandler = {
    onRetry: () => VoidReturn;
};

export type TroubleShootingResource = {
    header: HeaderResource;
    image: ImageResource;
    troubleShootingMessage: TextResource;
    buttonLabel: ButtonResource;
    customerSupportMessage: TextResource;
    customerSupportLink: TextResource;
};

export interface ITroubleShooting {
    useHandler: () => TroubleShootingHandler;
    useResource: () => TroubleShootingResource;
}

export default function TroubleShooting({
    useHandler,
    useResource,
}: ITroubleShooting): JSX.Element {
    const {
        header,
        image,
        troubleShootingMessage,
        buttonLabel,
        customerSupportMessage,
        customerSupportLink,
    } = useResource();

    const { onRetry } = useHandler();

    return (
        <AppContainer>
            <Header headerContent={header} />
            <BodyContainer>
                <CustomImg
                    imgType={'small'}
                    id={image.id}
                    src={image.src}
                    alt={image.alt}
                    className="TroubleShooting-image"
                />
                <BulletList
                    id={troubleShootingMessage.id}
                    bulletItems={troubleShootingMessage.text.split('|')}
                />
            </BodyContainer>
            <CustomButton
                buttonType={ButtonType.Primary}
                id={buttonLabel.id}
                onClick={onRetry}
            >
                {buttonLabel.label}
            </CustomButton>
            <CustomTypography
                id={customerSupportMessage.id}
                type={TypographyType.notoSansBody}
                text={customerSupportMessage.text}
            />
            <CustomTypography
                id={customerSupportLink.id}
                type={TypographyType.notoSansBody}
                text={customerSupportLink.text}
                className="TroubleShooting-customer-support-link"
            />
        </AppContainer>
    );
}
